export const STATS_ENDPOINTS = {
  OVERVIEW: '/api/v1/estadisticas/overview',
  CHARTS: '/api/v1/estadisticas/charts',
} as const;
